import React from 'react';
import { ContractorsCard } from '../../contractors/components/ContractorsCard';
import { PsPage } from '../../shared/components/ps-page/PsPage';
import { I18nUtils } from '../../../i18n/I18nUtils';
import PropTypes from 'prop-types';

export class SuperAdminDashboard extends React.Component {

    render() {
        const { breadcrumbs } = this.props;

        return (
            <PsPage title={I18nUtils.tr('TR_INICIO')} breadcrumbs={breadcrumbs}>
                <ContractorsCard/>
            </PsPage>
        );
    }
}

SuperAdminDashboard.propTypes = {
    breadcrumbs: PropTypes.array.isRequired,
};

SuperAdminDashboard.defaultProps = {};



// WEBPACK FOOTER //
// ./src/app/dashboard/dashboards/SuperAdminDashboard.jsx